import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-insights',
  templateUrl: './insights.component.html',
  styleUrls: ['./insights.component.css']
})
export class InsightsComponent implements OnInit {
  @Input() entityId: any;
  insightTabIndex: number = 0;
  constructor() { }

  ngOnInit(): void {
  }

  insightsTabChanged(event: any) {
    this.insightTabIndex = event.index;
    window.dispatchEvent(new Event('resize'));
  }

}
